import { useContext, useState } from "react";
import ExperienceContext from "./ExperienceContext";
import {
	Header,
	Button,
	TextInput,
	MediaQuery,
	Burger,
	Image,
	Group,
	Loader,
	useMantineTheme,
} from "@mantine/core";
import axios from "axios";
import { LOCAL_URL } from "../../constant";
import eye from "../../static/svg/eye.svg";
import rightArrow from "../../static/svg/right-arrow.svg";
import leftArrow from "../../static/svg/leftArrow.svg";
import editPanoName from "../../static/svg/edit-pano-name.svg";
import IvisitLogo from "../../static/images/logo.png";
import { Link, useNavigate } from "react-router-dom";
import {
	showErrorNotification,
	showSuccessNotification,
} from "../../utils/Notifications";
function HeaderNav({
	opened,
	setOpened,
	space,
	panoramaDetails,
	toggleComponent,
}) {
	const theme = useMantineTheme();
	const { experience, updatePanoramaName } = useContext(ExperienceContext);
	const [loading, setLoading] = useState(false);
	const navigate = useNavigate();

	const onClickExit = () => {
		navigate(-1);
	};
	const onClickSave = (space) => {
		setLoading(true);
		let tempSpace = { ...space };
		let tempExp = JSON.parse(tempSpace.Experiences);
		tempExp.panoramas = experience;
		axios
			.patch(LOCAL_URL + `/space/updateExperianceJson/${space.id}`, {
				Experiences: tempExp,
			})
			.then((res) => {
				showSuccessNotification("Experience was saved");
				setLoading(false);
			})
			.catch((err) => {
				showErrorNotification(
					"Experience could not be saved. Please try again."
				);
				setLoading(false);
			});
	};

	return (
		<Header
			height={45}
			p="md"
			sx={(theme) => ({
				backgroundColor: theme.colors.ivisit_dark[0],
				border: "none",
			})}
		>
			{loading && (
				<div className="LoadingModal">
					<Loader className="LoadingModal_loader" />
				</div>
			)}
			<div
				style={{
					display: "flex",
					alignItems: "center",
					height: "100%",
					width: "100%",
					justifyContent: "space-between",
				}}
			>
				<MediaQuery largerThan="sm" styles={{ display: "none" }}>
					<Burger
						opened={opened}
						onClick={() => setOpened((o) => !o)}
						size="sm"
						color={theme.colors.gray[6]}
						mr="xl"
					/>
				</MediaQuery>
				<Link to={"/dashboard"}>
					<Group position={"left"}>
						<Image src={IvisitLogo} alt="Ivisit" />
					</Group>
				</Link>
				{panoramaDetails ? (
					<Group position="center">
						<TextInput
							size="xs"
							placeholder="Panorama name"
							value={panoramaDetails.name}
							rightSection={
								<Image
									style={{ maxWidth: "50%" }}
									src={editPanoName}
								/>
							}
							onChange={(event) => {
								updatePanoramaName(
									panoramaDetails.id,
									event.target.value
								);
							}}
						/>
					</Group>
				) : null}
				<Group position={"right"}>
					<Button
						variant="outline"
						size="xs"
						radius={"md"}
						leftIcon={
							<Image src={leftArrow} height={19} width={19} />
						}
						sx={(theme) => ({
							color: theme.colors.white[0],
							borderColor: theme.colors.ivisit_light[0],
						})}
						onClick={onClickExit}
					>
						Exit
					</Button>
					<Button
						variant="outline"
						size="xs"
						radius={"md"}
						rightIcon={<Image src={eye} />}
						sx={(theme) => ({
							color: theme.colors.white[0],
							borderColor: theme.colors.ivisit_light[0],
						})}
						onClick={toggleComponent}
					>
						Preview
					</Button>
					<Button
						size="xs"
						radius={"md"}
						rightIcon={<Image src={rightArrow} />}
						sx={(theme) => ({
							backgroundColor: theme.colors.ivisit_light[0],
							"&:hover": {
								backgroundColor: theme.colors.ivisit_dark[1],
								borderColor: theme.colors.ivisit_light[0],
							},
						})}
						onClick={() => {
							onClickSave(space);
						}}
					>
						Save
					</Button>
				</Group>
			</div>
		</Header>
	);
}

export default HeaderNav;
